import i18n from '@/lang'

export default {
  path: '/subscription-plans',
  name: 'subscription-plans',
  component: () => import('@pt/views/payment-package/index'),
  hidden: true,
  meta: {
    payment: 'free',
    title: i18n.t('playTurbo.payment.router.title'),
    defaultPath: '/subscription-plans',
  },
}
